export enum TableName {
	USER_PROFILE = 'user_profile_user',
	RESERVATION = 'reservation_reservation',
	SEASON_TERM = 'transport_term',
	ORGANIZATION = 'organization_organization',
	PAYMENT_TERM = 'payment_term',
}
